import React, { useState } from 'react';

const C = {
 accent:'#3AAF58', accentLight:'#EAF7EE',
 bg:'#0A1628', surface:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 amber:'#D4840F', amberBg:'rgba(245,158,11,.1)', amberBorder:'#F0D499',
 red:'#EF4444', redBg:'rgba(239,68,68,.1)', redBorder:'#F0B8B8',
 blue:'#FFFFFF', blueBg:'#EAF1FB',
 purple:'#6B48A8', purpleBg:'#F0EBFB',
 green:'#25D366', greenBg:'#E8FBF0',
 dark:'#0F1E14',
};

const todayStr = () => new Date().toISOString().slice(0,10);
const timeStr = () => new Date().toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'});

// ── TEMPLATES ─────────────────────────────────────────────────────────────────
const EMAIL_TEMPLATES = [
 {
 id:'booking_confirm',
 name:'Booking Confirmation',
 trigger:'Auto — when booking is created',
 color:C.accent,
 subject:'Booking Confirmed — Botanix Nature Resort | {booking_id}',
 body:`Dear {guest_name},

Thank you for choosing Botanix Nature Resort! We are delighted to confirm your booking.


BOOKING DETAILS

Booking ID : {booking_id}
Event Date : {event_date}
Package : {package_name}
No. of Guests : {pax} persons
Venue : {venue}
Report Time : {report_time}


PAYMENT SUMMARY

Total Amount : ₹{total_amount}
Advance Paid : ₹{advance_paid}
Balance Due : ₹{balance_due}
Due Date : {due_date}


CONTACT US

 +91 98100 00000
 info@botanix.in
 www.botanix.in
 Village Damdama, Tehsil Sohna, Gurgaon-122102, Haryana

We look forward to hosting you!

Warm regards,
Sales Team
Botanix Nature Resort`,
 },
 {
 id:'invoice_send',
 name:'Invoice / Bill',
 trigger:'Auto — when invoice is generated',
 color:C.blue,
 subject:'Invoice {invoice_no} — Botanix Nature Resort',
 body:`Dear {guest_name},

Please find your invoice details below for your recent event at Botanix Nature Resort.

Invoice No : {invoice_no}
Invoice Date : {invoice_date}
Booking Ref : {booking_id}
Total Amount : ₹{total_amount}
GST (CGST+SGST): ₹{gst_amount}
Amount Paid : ₹{amount_paid}
Balance Due : ₹{balance_due}

PAYMENT OPTIONS

Bank Transfer : ICICI Bank | A/C: 031405004054 | IFSC: ICIC0000314
UPI : botanix@icici
Cheque : "Botanix Nature Resort"

For any queries, contact accounts@botanix.in or call +91 98100 00000.

Warm regards,
Accounts Team
Botanix Nature Resort`,
 },
 {
 id:'payment_receipt',
 name:'Payment Receipt',
 trigger:'Auto — when payment is recorded',
 color:C.accent,
 subject:'Payment Received — ₹{amount} | {booking_id}',
 body:`Dear {guest_name},

We have received your payment. Thank you!

Payment Details

Amount Received : ₹{amount}
Payment Mode : {payment_mode}
Transaction Ref : {transaction_ref}
Date : {payment_date}
Booking ID : {booking_id}
Balance Due : ₹{balance_due}

{balance_due_message}

For any queries, contact accounts@botanix.in

Warm regards,
Accounts Team
Botanix Nature Resort`,
 },
 {
 id:'day_before',
 name:'Day Before Reminder',
 trigger:'Auto — 1 day before event date',
 color:C.amber,
 subject:'See You Tomorrow! — Botanix Nature Resort | {booking_id}',
 body:`Dear {guest_name},

We are excited to welcome you tomorrow at Botanix Nature Resort!

REMINDER

Event Date : {event_date} (Tomorrow!)
Report Time : {report_time}
No. of Guests : {pax} persons
Balance Due : ₹{balance_due}

DIRECTIONS

 Botanix Nature Resort, Village Damdama, Tehsil Sohna, Gurgaon-122102, Haryana, India
 From Delhi: 45 mins via NH-48
 From Gurugram: 30 mins via NH-48

THINGS TO CARRY

 Valid ID proof for all guests
 Comfortable clothes & footwear
 Sunscreen & sunglasses
 This booking confirmation

Looking forward to an amazing day!

Warm regards,
Guest Relations
Botanix Nature Resort`,
 },
 {
 id:'thank_you',
 name:'Thank You / Feedback',
 trigger:'Auto — 1 day after event',
 color:C.purple,
 subject:'Thank You for Visiting Botanix! Share Your Experience',
 body:`Dear {guest_name},

Thank you for choosing Botanix Nature Resort for your {event_type}! We hope you had a wonderful experience.

We would love to hear your feedback:
 Google Review: g.page/botanix-nature-resort
 TripAdvisor: tripadvisor.com/botanix
 Tag us on Instagram: @BotanixResort

Share your photos with #BotanixNatureResort and get featured on our page!

BOOK AGAIN & SAVE 10%

Use code BOTANIX10 for 10% off your next booking.
Valid for 3 months from your visit date.

 +91 98100 00000 | www.botanix.in

With warm regards,
Team Botanix
Botanix Nature Resort`,
 },
 {
 id:'cancellation',
 name:'Cancellation Confirmation',
 trigger:'Manual — when booking is cancelled',
 color:C.red,
 subject:'Booking Cancelled — {booking_id} | Botanix Nature Resort',
 body:`Dear {guest_name},

As requested, your booking has been cancelled.

Cancelled Booking : {booking_id}
Event Date : {event_date}
Cancellation Date : {cancellation_date}
Refund Amount : ₹{refund_amount}
Refund Timeline : 7-10 working days

The refund will be processed to your original payment method.

We hope to host you in the future. For any queries:
 +91 98100 00000 | info@botanix.in

Warm regards,
Botanix Nature Resort`,
 },
];

const WHATSAPP_TEMPLATES = [
 {
 id:'wa_booking',
 name:'Booking Confirmed',
 trigger:'Auto — when booking is created',
 color:C.green,
 message:` *Booking Confirmed!*
Botanix Nature Resort

Hello {guest_name}! 

Your booking is confirmed 

 *Booking ID:* {booking_id}
 *Date:* {event_date}
 *Guests:* {pax} persons
 *Total:* ₹{total_amount}
 *Advance Paid:* ₹{advance_paid}
 *Balance:* ₹{balance_due}

 Village Damdama, Tehsil Sohna, Gurgaon-122102, Haryana
 +91 98100 00000
 www.botanix.in

See you on {event_date}! `,
 },
 {
 id:'wa_payment',
 name:'Payment Received',
 trigger:'Auto — when payment recorded',
 color:C.green,
 message:` *Payment Received!*
Botanix Nature Resort

Dear {guest_name},

We have received your payment 

 *Amount:* ₹{amount}
 *Mode:* {payment_mode}
 *Ref:* {transaction_ref}
 *Booking:* {booking_id}
 *Balance:* ₹{balance_due}

Thank you! 
 +91 98100 00000`,
 },
 {
 id:'wa_reminder',
 name:'Day Before Reminder',
 trigger:'Auto — 1 day before event',
 color:C.amber,
 message:` *See You Tomorrow!*
Botanix Nature Resort

Hello {guest_name}! 

Your event is *tomorrow* 

 *Date:* {event_date}
 *Report Time:* {report_time}
 *Guests:* {pax} persons

 *Directions:*
Village Damdama, Tehsil Sohna, Gurgaon-122102, Haryana
45 mins from Delhi via NH-48

 Carry valid ID proof
 Comfortable clothes & footwear

We look forward to hosting you!
 +91 98100 00000`,
 },
 {
 id:'wa_invoice',
 name:'Invoice Sent',
 trigger:'Auto — when invoice generated',
 color:C.blue,
 message:` *Invoice from Botanix*
Nature Resort

Dear {guest_name},

Your invoice is ready 

 *Invoice No:* {invoice_no}
 *Date:* {invoice_date}
 *Total:* ₹{total_amount}
 *Paid:* ₹{amount_paid}
 *Balance:* ₹{balance_due}

 *Pay via UPI:* botanix@icici

For queries: accounts@botanix.in
 +91 98100 00000`,
 },
 {
 id:'wa_thankyou',
 name:'Thank You',
 trigger:'Auto — 1 day after event',
 color:C.purple,
 message:` *Thank You!*
Botanix Nature Resort

Dear {guest_name},

It was wonderful hosting you! 

 Please share your experience:
*Google:* g.page/botanix
*Instagram:* @BotanixResort

 Tag us: *#BotanixNatureResort*

 *Book Again & Save 10%*
Use code: *BOTANIX10*
Valid for 3 months!

 +91 98100 00000
 www.botanix.in`,
 },
];

// ── NOTIFICATION LOG (sample) ─────────────────────────────────────────────────
const NOTIF_LOG = [
 {id:1,type:'Email',template:'Booking Confirmation',recipient:'rajesh@abctech.com',booking:'BTX-1044',sentAt:'2026-07-03 09:15',status:'Delivered',channel:'Email'},
 {id:2,type:'WhatsApp',template:'Booking Confirmed',recipient:'+91 98100 01234',booking:'BTX-1044',sentAt:'2026-07-03 09:15',status:'Delivered',channel:'WhatsApp'},
 {id:3,type:'Email',template:'Invoice / Bill',recipient:'rajesh@abctech.com',booking:'BTX-1044',sentAt:'2026-07-03 11:30',status:'Delivered',channel:'Email'},
 {id:4,type:'WhatsApp',template:'Invoice Sent',recipient:'+91 98100 01234',booking:'BTX-1044',sentAt:'2026-07-03 11:30',status:'Delivered',channel:'WhatsApp'},
 {id:5,type:'Email',template:'Day Before Reminder',recipient:'vikram@sharma.com',booking:'BTX-1038',sentAt:'2026-07-02 10:00',status:'Delivered',channel:'Email'},
 {id:6,type:'WhatsApp',template:'Day Before Reminder',recipient:'+91 98100 05678',booking:'BTX-1038',sentAt:'2026-07-02 10:00',status:'Delivered',channel:'WhatsApp'},
 {id:7,type:'Email',template:'Payment Receipt',recipient:'principal@greenvalley.edu',booking:'BTX-1055',sentAt:'2026-07-03 14:20',status:'Delivered',channel:'Email'},
 {id:8,type:'WhatsApp',template:'Payment Received',recipient:'+91 98100 09012',booking:'BTX-1055',sentAt:'2026-07-03 14:20',status:'Failed',channel:'WhatsApp'},
 {id:9,type:'Email',template:'Thank You / Feedback',recipient:'priya.nair@greenvalley.edu',booking:'BTX-1050',sentAt:'2026-07-02 09:00',status:'Delivered',channel:'Email'},
 {id:10,type:'WhatsApp',template:'Thank You',recipient:'+91 98100 07890',booking:'BTX-1050',sentAt:'2026-07-02 09:00',status:'Delivered',channel:'WhatsApp'},
];


// ── ATOMS ─────────────────────────────────────────────────────────────────────
const Card = ({children,style={}}) => <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,boxShadow:'0 1px 4px rgba(0,0,0,.05)',...style}}>{children}</div>;
const SH = ({title,icon,color,bg,right}) => (
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'13px 18px',borderBottom:`1px solid ${C.border}`,background:bg||'#F5F8F5',borderRadius:'12px 12px 0 0'}}>
 <div style={{display:'flex',alignItems:'center',gap:8}}><span style={{fontSize:18}}>{icon}</span><span style={{fontSize:14,fontWeight:700,color:color||C.text}}>{title}</span></div>
 {right}
 </div>
);
const Btn = ({children,onClick,variant='primary',style={},disabled}) => {
 const v={primary:{background:C.accent,color:'#fff',border:'none'},ghost:{background:'transparent',color:C.text2,border:`1px solid ${C.border2}`},outline:{background:'transparent',color:C.accent,border:`1px solid ${C.accent}`},green:{background:C.green,color:'#fff',border:'none'},amber:{background:C.amberBg,color:C.amber,border:`1px solid ${C.amberBorder}`}};
 return <button onClick={onClick} disabled={disabled} style={{...v[variant]||v.primary,padding:'8px 16px',borderRadius:8,fontSize:13,fontWeight:600,cursor:disabled?'not-allowed':'pointer',opacity:disabled?.5:1,display:'inline-flex',alignItems:'center',gap:6,whiteSpace:'nowrap',...style}}>{children}</button>;
};
const KPI = ({label,value,icon,color,bg,sub}) => (
 <Card style={{padding:16}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
 <div style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.07em'}}>{label}</div>
 <div style={{width:30,height:30,borderRadius:8,background:bg||C.accentLight,display:'flex',alignItems:'center',justifyContent:'center',fontSize:15}}>{icon}</div>
 </div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:color||C.text}}>{value}</div>
 {sub&&<div style={{fontSize:11,color:C.text3,marginTop:3}}>{sub}</div>}
 </Card>
);
const Toggle = ({checked,onChange,label}) => (
 <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer'}}>
 <div onClick={()=>onChange(!checked)} style={{width:38,height:20,borderRadius:99,background:checked?C.accent:C.border2,position:'relative',transition:'background .2s',cursor:'pointer',flexShrink:0}}>
 <div style={{position:'absolute',top:3,left:checked?20:3,width:14,height:14,borderRadius:'50%',background:'#006b3c',transition:'left .2s',boxShadow:'0 1px 3px rgba(0,0,0,.2)'}}/>
 </div>
 {label&&<span style={{fontSize:12,fontWeight:500,color:C.text2}}>{label}</span>}
 </label>
);

// ── SEND TEST MODAL ───────────────────────────────────────────────────────────
function SendTestModal({template, type, onClose, onSend}) {
 const [to, setTo] = useState(type==='WhatsApp'?'+91 98100 00000':'test@botanix.in');
 const [sending, setSending] = useState(false);
 const [sent, setSent] = useState(false);

 const send = () => {
 setSending(true);
 setTimeout(()=>{setSending(false);setSent(true);setTimeout(()=>{onSend();onClose();},1500);},2000);
 };

 return (
 <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
 <Card style={{width:480,padding:28,boxShadow:'0 24px 64px rgba(0,0,0,.2)'}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:17,fontWeight:800,color:C.text}}>Send Test {type}</div>
 <button onClick={onClose} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:8,width:30,height:30,cursor:'pointer',color:C.text2,fontSize:14}}></button>
 </div>

 <div style={{padding:'12px 16px',background:type==='WhatsApp'?C.greenBg:C.blueBg,borderRadius:9,marginBottom:16,border:`1px solid ${type==='WhatsApp'?C.green:C.blue}44`}}>
 <div style={{fontSize:12,fontWeight:700,color:type==='WhatsApp'?C.green:C.blue,marginBottom:2}}>{template.name}</div>
 <div style={{fontSize:11,color:C.text3}}>{template.trigger}</div>
 </div>

 <div style={{marginBottom:16}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:6}}>{type==='WhatsApp'?'WhatsApp Number':'Email Address'}</div>
 <input value={to} onChange={e=>setTo(e.target.value)}
 style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',boxSizing:'border-box'}}/>
 <div style={{fontSize:11,color:C.text3,marginTop:4}}>Sample data will be used for {'{variables}'}</div>
 </div>

 {sent
 ? <div style={{padding:'14px',background:C.accentLight,borderRadius:9,textAlign:'center',fontSize:14,fontWeight:700,color:C.accent}}> Test {type} sent successfully!</div>
 : <div style={{display:'flex',gap:10}}>
 <Btn onClick={send} disabled={sending} variant={type==='WhatsApp'?'green':'primary'} style={{flex:1,justifyContent:'center'}}>
 {sending?'Sending…':`Send Test ${type}`}
 </Btn>
 <Btn variant="ghost" onClick={onClose} style={{flex:1,justifyContent:'center'}}>Cancel</Btn>
 </div>
 }
 </Card>
 </div>
 );
}

// ── TEMPLATE CARD ─────────────────────────────────────────────────────────────
function TemplateCard({template, type, enabled, onToggle, onTest, onEdit}) {
 const [expanded, setExpanded] = useState(false);
 const isWA = type === 'WhatsApp';

 return (
 <Card style={{overflow:'hidden',opacity:enabled?1:.7}}>
 <div style={{padding:'14px 18px',display:'flex',alignItems:'center',gap:12}}>
 <div style={{width:42,height:42,borderRadius:11,background:template.color+'18',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0}}>{template.icon}</div>
 <div style={{flex:1}}>
 <div style={{fontWeight:700,fontSize:14,color:C.text,marginBottom:2}}>{template.name}</div>
 <div style={{fontSize:11,color:C.text3}}>{template.trigger}</div>
 </div>
 <div style={{display:'flex',gap:8,alignItems:'center'}}>
 <Btn variant="ghost" style={{fontSize:11,padding:'5px 10px'}} onClick={()=>setExpanded(!expanded)}>
 {expanded?' Hide':' Preview'}
 </Btn>
 <Btn variant={isWA?'green':'outline'} style={{fontSize:11,padding:'5px 10px'}} onClick={onTest}>
 {isWA?' Test WA':' Test Email'}
 </Btn>
 <Toggle checked={enabled} onChange={onToggle}/>
 </div>
 </div>

 {expanded&&(
 <div style={{borderTop:`1px solid ${C.border}`,padding:'16px 18px',background:isWA?C.greenBg:C.bg}}>
 {isWA
 ? <div style={{background:'#006b3c',borderRadius:12,padding:'14px 16px',maxWidth:340,boxShadow:'0 2px 8px rgba(0,0,0,.08)',fontSize:13,lineHeight:1.7,whiteSpace:'pre-line',fontFamily:'Arial,sans-serif',color:'#1A2E1E',border:`1px solid ${C.border}`}}>
 {template.message}
 </div>
 : <div>
 <div style={{padding:'10px 14px',background:C.border,borderRadius:'8px 8px 0 0',fontSize:12,fontWeight:600,color:C.text2}}>
 <span style={{color:C.text3}}>Subject: </span>{template.subject}
 </div>
 <div style={{padding:'14px 16px',background:'#006b3c',borderRadius:'0 0 8px 8px',border:`1px solid ${C.border}`,fontSize:12,lineHeight:1.8,whiteSpace:'pre-line',fontFamily:'Arial,sans-serif',color:C.text,maxHeight:200,overflowY:'auto'}}>
 {template.body}
 </div>
 </div>
 }
 <div style={{display:'flex',gap:8,marginTop:12}}>
 <Btn variant="ghost" style={{fontSize:11,padding:'5px 12px'}} onClick={onEdit}> Edit Template</Btn>
 <span style={{fontSize:11,color:C.text3,alignSelf:'center'}}>Variables: {'{guest_name}'} {'{booking_id}'} {'{event_date}'} {'{total_amount}'}</span>
 </div>
 </div>
 )}
 </Card>
 );
}

// ── MANUAL SEND ───────────────────────────────────────────────────────────────
function ManualSend({onSend}) {
 const [form, setForm] = useState({booking:'',guest:'',phone:'',email:'',template:'booking_confirm',channel:'Both'});
 const [sending, setSending] = useState(false);
 const [sent, setSent] = useState(false);
 const upd = k => v => setForm(p=>({...p,[k]:v}));
 const inp = (label,key,placeholder,type='text') => (
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>{label}</div>
 <input type={type} value={form[key]} onChange={e=>upd(key)(e.target.value)} placeholder={placeholder}
 style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',boxSizing:'border-box'}}/>
 </div>
 );

 const send = () => {
 if(!form.booking||!form.guest) return alert('Enter booking ID and guest name');
 setSending(true);
 setTimeout(()=>{setSending(false);setSent(true);onSend({...form,sentAt:todayStr()+' '+timeStr(),status:'Delivered'});setTimeout(()=>setSent(false),3000);},2000);
 };

 return (
 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:C.text,marginBottom:16}}> Send Notification Manually</div>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
 {inp('Booking ID','booking','BTX-1044')}
 {inp('Guest Name','guest','Rajesh Kumar')}
 {inp('WhatsApp Number','phone','+91 98100 00000')}
 {inp('Email Address','email','guest@email.com','email')}
 </div>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>Template</div>
 <select value={form.template} onChange={e=>upd('template')(e.target.value)}
 style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif'}}>
 {[...EMAIL_TEMPLATES,...WHATSAPP_TEMPLATES.filter(w=>!EMAIL_TEMPLATES.find(e=>e.id===w.id.replace('wa_','')))].map(t=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={t.id} value={t.id}>{t.name}</option>)}
 </select>
 </div>
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>Send Via</div>
 <select value={form.channel} onChange={e=>upd('channel')(e.target.value)}
 style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif'}}>
 {['Both Email & WhatsApp','Email Only','WhatsApp Only'].map(o=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={o}>{o}</option>)}
 </select>
 </div>
 </div>
 {sent
 ? <div style={{padding:'12px 16px',background:C.accentLight,borderRadius:9,fontSize:13,fontWeight:700,color:C.accent,textAlign:'center'}}> Notification sent successfully!</div>
 : <div style={{display:'flex',gap:10}}>
 <Btn onClick={send} disabled={sending} style={{flex:1,justifyContent:'center'}}>{sending?'Sending…':' Send Now'}</Btn>
 <Btn variant="green" style={{flex:1,justifyContent:'center'}} disabled={sending}> Send WhatsApp</Btn>
 </div>
 }
 </Card>
 );
}


// ── MAIN MODULE ───────────────────────────────────────────────────────────────
const TABS = [
 {id:'dashboard', label:'Dashboard', },
 {id:'email', label:'Email Templates', },
 {id:'whatsapp', label:'WhatsApp Templates',},
 {id:'log', label:'Notification Log', },
 {id:'settings', label:'Settings', },
];

export default function Notifications() {
 const [tab, setTab] = useState('dashboard');
 const [log, setLog] = useState(NOTIF_LOG);
 const [testModal, setTestModal] = useState(null);
 const [emailEnabled, setEmailEnabled] = useState(EMAIL_TEMPLATES.reduce((a,t)=>({...a,[t.id]:true}),{}));
 const [waEnabled, setWaEnabled] = useState(WHATSAPP_TEMPLATES.reduce((a,t)=>({...a,[t.id]:true}),{}));

 const addLog = (entry) => setLog(p=>[{id:Date.now(),type:entry.channel?.includes('WhatsApp')?'WhatsApp':'Email',template:entry.template||'Manual',recipient:entry.email||entry.phone,booking:entry.booking,sentAt:entry.sentAt,status:'Delivered',channel:entry.channel},...p]);

 const delivered = log.filter(l=>l.status==='Delivered').length;
 const failed = log.filter(l=>l.status==='Failed').length;
 const todayLog = log.filter(l=>l.sentAt?.startsWith(todayStr()));

 return (
 <div style={{fontFamily:'Inter,sans-serif',color:C.text}}>
 {/* Header */}
 <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:'0 28px',position:'sticky',top:0,zIndex:50}}>
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',height:62}}>
 <div>
 <div style={{fontSize:11,color:C.text3,fontWeight:500,marginBottom:1}}>Communication Centre</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:C.text}}>Email & WhatsApp Notifications</div>
 </div>
 <div style={{display:'flex',gap:10,alignItems:'center'}}>
 <div style={{padding:'7px 14px',background:C.accentLight,borderRadius:9}}>
 <span style={{fontSize:12,fontWeight:700,color:C.accent}}>{delivered} Delivered Today</span>
 </div>
 {failed>0&&<div style={{padding:'7px 14px',background:C.redBg,borderRadius:9}}>
 <span style={{fontSize:12,fontWeight:700,color:C.red}}>{failed} Failed</span>
 </div>}
 </div>
 </div>
 <div style={{display:'flex',gap:0,overflowX:'auto'}}>
 {TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{padding:'10px 16px',background:'transparent',border:'none',cursor:'pointer',fontSize:13,fontWeight:600,color:tab===t.id?C.accent:C.text3,borderBottom:`2px solid ${tab===t.id?C.accent:'transparent'}`,whiteSpace:'nowrap',display:'flex',alignItems:'center',gap:5}}>
 {t.icon} {t.label}
 </button>
 ))}
 </div>
 </div>

 <div style={{padding:'24px 28px'}}>

 {/* DASHBOARD */}
 {tab==='dashboard'&&(
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:12,marginBottom:20}}>
 <KPI label="Total Sent" value={log.length} icon="" color={C.text}/>
 <KPI label="Delivered" value={delivered} icon="" color={C.accent}/>
 <KPI label="Failed" value={failed} icon="" color={failed>0?C.red:C.text3} bg={failed>0?C.redBg:C.border}/>
 <KPI label="Sent Today" value={todayLog.length} icon="" color={C.blue} bg={C.blueBg}/>
 <KPI label="Delivery Rate" value={Math.round(delivered/log.length*100)+'%'} icon="" color={C.accent}/>
 </div>

 {/* Auto triggers status */}
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:20}}>
 <Card>
 <SH title="Email Auto-Triggers" icon="" color={C.blue} bg={C.blueBg}
 right={<span style={{fontSize:11,color:C.accent,fontWeight:600}}>All Active </span>}/>
 <div style={{padding:'14px 18px',display:'flex',flexDirection:'column',gap:8}}>
 {EMAIL_TEMPLATES.map(t=>(
 <div key={t.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',background:emailEnabled[t.id]?C.accentLight:C.bg,borderRadius:9,border:`1px solid ${emailEnabled[t.id]?C.accent:C.border}`}}>
 <span style={{fontSize:16}}>{t.icon}</span>
 <div style={{flex:1}}>
 <div style={{fontSize:12,fontWeight:600,color:C.text}}>{t.name}</div>
 <div style={{fontSize:10,color:C.text3}}>{t.trigger}</div>
 </div>
 <Toggle checked={emailEnabled[t.id]||false} onChange={v=>setEmailEnabled(p=>({...p,[t.id]:v}))}/>
 </div>
 ))}
 </div>
 </Card>

 <Card>
 <SH title="WhatsApp Auto-Triggers" icon="" color={C.green} bg={C.greenBg}
 right={<span style={{fontSize:11,color:C.accent,fontWeight:600}}>All Active </span>}/>
 <div style={{padding:'14px 18px',display:'flex',flexDirection:'column',gap:8}}>
 {WHATSAPP_TEMPLATES.map(t=>(
 <div key={t.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',background:waEnabled[t.id]?C.greenBg:C.bg,borderRadius:9,border:`1px solid ${waEnabled[t.id]?C.green:C.border}`}}>
 <span style={{fontSize:16}}>{t.icon}</span>
 <div style={{flex:1}}>
 <div style={{fontSize:12,fontWeight:600,color:C.text}}>{t.name}</div>
 <div style={{fontSize:10,color:C.text3}}>{t.trigger}</div>
 </div>
 <Toggle checked={waEnabled[t.id]||false} onChange={v=>setWaEnabled(p=>({...p,[t.id]:v}))}/>
 </div>
 ))}
 </div>
 </Card>
 </div>

 {/* Manual send */}
 <ManualSend onSend={addLog}/>
 </div>
 )}

 {/* EMAIL TEMPLATES */}
 {tab==='email'&&(
 <div>
 <div style={{padding:'12px 18px',background:C.blueBg,border:`1px solid ${C.blue}44`,borderRadius:10,marginBottom:16,fontSize:13,color:C.blue}}>
 <strong>Email Integration:</strong> Connect via SMTP (Gmail / Outlook / SendGrid). Configure in Settings tab. All templates support variables like {'{guest_name}'}, {'{booking_id}'}, {'{total_amount}'}.
 </div>
 <div style={{display:'flex',flexDirection:'column',gap:12}}>
 {EMAIL_TEMPLATES.map(t=>(
 <TemplateCard key={t.id} template={t} type="Email"
 enabled={emailEnabled[t.id]||false}
 onToggle={v=>setEmailEnabled(p=>({...p,[t.id]:v}))}
 onTest={()=>setTestModal({template:t,type:'Email'})}
 onEdit={()=>alert('Template editor coming soon!')}/>
 ))}
 </div>
 </div>
 )}

 {/* WHATSAPP TEMPLATES */}
 {tab==='whatsapp'&&(
 <div>
 <div style={{padding:'12px 18px',background:C.greenBg,border:`1px solid ${C.green}44`,borderRadius:10,marginBottom:16,fontSize:13,color:'#1A7A4A'}}>
 <strong>WhatsApp Integration:</strong> Connect via Wati.io or Meta WhatsApp Business API. All messages are pre-approved business templates. Configure API keys in Settings tab.
 </div>
 <div style={{display:'flex',flexDirection:'column',gap:12}}>
 {WHATSAPP_TEMPLATES.map(t=>(
 <TemplateCard key={t.id} template={t} type="WhatsApp"
 enabled={waEnabled[t.id]||false}
 onToggle={v=>setWaEnabled(p=>({...p,[t.id]:v}))}
 onTest={()=>setTestModal({template:t,type:'WhatsApp'})}
 onEdit={()=>alert('Template editor coming soon!')}/>
 ))}
 </div>
 </div>
 )}

 {/* NOTIFICATION LOG */}
 {tab==='log'&&(
 <Card>
 <SH title="Notification Delivery Log" icon="" color={C.text}
 right={<span style={{fontSize:11,color:C.text3}}>Last {log.length} notifications</span>}/>
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead><tr style={{background:'#F5F8F5'}}>
 {['Channel','Template','Recipient','Booking','Sent At','Status'].map(h=>(
 <th key={h} style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'left',borderBottom:`1px solid ${C.border}`}}>{h}</th>
 ))}
 </tr></thead>
 <tbody>
 {log.map((l,i)=>(
 <tr key={l.id} style={{borderBottom:`1px solid ${C.border}`,background:i%2===0?'#FAFCFA':C.surface}}>
 <td style={{padding:'11px 14px'}}>
 <span style={{padding:'3px 10px',borderRadius:99,fontSize:11,fontWeight:600,color:l.channel==='WhatsApp'?C.green:C.blue,background:l.channel==='WhatsApp'?C.greenBg:C.blueBg}}>
 {l.channel==='WhatsApp'?'':''} {l.channel}
 </span>
 </td>
 <td style={{padding:'11px 14px',fontSize:13,fontWeight:500}}>{l.template}</td>
 <td style={{padding:'11px 14px',fontSize:12,color:C.text2,fontFamily:'monospace'}}>{l.recipient}</td>
 <td style={{padding:'11px 14px',fontSize:12,color:C.blue,fontWeight:600}}>{l.booking}</td>
 <td style={{padding:'11px 14px',fontSize:12,color:C.text3}}>{l.sentAt}</td>
 <td style={{padding:'11px 14px'}}>
 <span style={{padding:'3px 10px',borderRadius:99,fontSize:11,fontWeight:600,color:l.status==='Delivered'?C.accent:C.red,background:l.status==='Delivered'?C.accentLight:C.redBg}}>
 {l.status==='Delivered'?'':''} {l.status}
 </span>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </Card>
 )}

 {/* SETTINGS */}
 {tab==='settings'&&(
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
 <Card style={{padding:24}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:C.text,marginBottom:4}}> Email Configuration</div>
 <div style={{fontSize:12,color:C.text3,marginBottom:16}}>Configure SMTP settings to send emails</div>
 {[['SMTP Host','smtp.gmail.com'],['SMTP Port','587'],['Email Address','info@botanix.in'],['Password / App Key','••••••••••••'],['From Name','Botanix Nature Resort']].map(([k,v])=>(
 <div key={k} style={{marginBottom:12}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>{k}</div>
 <input defaultValue={v} style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',boxSizing:'border-box'}}/>
 </div>
 ))}
 <Btn style={{width:'100%',justifyContent:'center',marginTop:4}}>Save Email Settings</Btn>
 </Card>

 <Card style={{padding:24}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:C.text,marginBottom:4}}> WhatsApp Configuration</div>
 <div style={{fontSize:12,color:C.text3,marginBottom:16}}>Connect via Wati.io or Meta Business API</div>
 {[['API Provider','Wati.io'],['API Endpoint','https://live-mt-server.wati.io/'],['API Key / Token','••••••••••••••••••••'],['WhatsApp Number','+91 98100 00000'],['Business Name','Botanix Nature Resort']].map(([k,v])=>(
 <div key={k} style={{marginBottom:12}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:5}}>{k}</div>
 <input defaultValue={v} style={{width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',boxSizing:'border-box'}}/>
 </div>
 ))}
 <Btn variant="green" style={{width:'100%',justifyContent:'center',marginTop:4}}>Save WhatsApp Settings</Btn>
 </Card>
 </div>
 )}
 </div>

 {/* Test modal */}
 {testModal&&(
 <SendTestModal template={testModal.template} type={testModal.type}
 onClose={()=>setTestModal(null)}
 onSend={()=>{addLog({channel:testModal.type,template:testModal.template.name,booking:'TEST',email:'test@botanix.in',phone:'+91 00000 00000',sentAt:todayStr()+' '+timeStr()});setTestModal(null);}}/>
 )}
 </div>
 );
}
